"use client"

import { Video } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `VideoIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const VideoIcon = component(Icon)({ as: Video })
